import fetchUserRoomById from './fetchUserRoomById'
import fetchUserRooms from './fetchUserRooms'

const UserAction = {
  fetchUserRoomById,
  fetchUserRooms
}

export default UserAction
